// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3WoZx","name":"ConsentHeader_name__2hyuU","birthday":"ConsentHeader_birthday__3_VtM","skeleton":"ConsentHeader_skeleton__lF0g3"};